import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LookupsService } from 'projects/shared/src/services/lookups.service';
import { Router } from '@angular/router';
import { SystemModule } from '../../features/central-hub/models/enums/SystemModule';
import { MenuListData } from 'projects/shared/src/services/navigation.service';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';

@Component({
  selector: 'app-tabs-layout',
  standalone: false,
  templateUrl: './tabs-layout.component.html'
})
export class TabsLayoutComponent implements OnInit, AfterViewInit {
  centralHubCode: SystemModule;
  nav: MenuListData = new MenuListData();

  isNavbarCollapsed = true;

  constructor(
    public authenticationService: AuthenticationService,
    public LookupsService: LookupsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.getMenuItems();
  }

  ngAfterViewInit() {
  }

  getMenuItems() {
    const currentUrl = this.router.url;
    const urlParts = currentUrl.split('/').filter(Boolean);
    const adminIndex = urlParts.indexOf('admin');
    if (adminIndex !== -1 && urlParts[adminIndex + 1]) {
      this.centralHubCode = urlParts[adminIndex + 1] as SystemModule;
    }
    this.LookupsService.getMenuBasedOnPermissions(this.centralHubCode).subscribe(
      (data: MenuListData) => {
        if (data && data.menuList && data.menuList.length > 0) {
          this.nav = data as MenuListData;
          if (urlParts.length < 3) {
            this.router.navigate([this.nav.menuList[0].route], { replaceUrl: true });
          }
        } else {
          this.router.navigate(['/admin/central-hub'], { replaceUrl: true });
        }
      },
      (error: any) => {
        this.authenticationService.logout();
      });
  }

  onOutletLoaded(component: any) {
    component.centralHubCode = SystemModule[this.centralHubCode];
  }
}
